import { browserLanguage } from './Common.js'

class Translate {
  constructor () {
    this.key = ''
    this.val = []
  }
  translate (key, ...val) {
    return language(key, val)
  }
}

function language (key, val) {
  let EN_US = {
    'title': 'Crait Invitation',
    'inviteTitle0': `Your friend ${val[0]} invites you to join ${val[1]}`,
    'inviteTitle1': `Your friend ${val[0]} invites you to join ${val[1]}`,
    'inviteTitle3': `You are invited to join group: ${val[0]}`,
    'newInviteTitle0': `${val[0]} is using crait, join now !`,
    'newInviteTitle1': `${val[0]} is using crait, join now !`,
    'newInviteTitle3': `You have joined secure group chat "${val[0]}"`,
    'newInviteTitle4': `Dear Crait user "${val[0]}", please enter your password to accept invitation`,
    'newInviteTitle5': `You and “${val[0]}” have been connected`,
    'newInviteTitle6': `You have joined group chat "${val[0]}"`,
    'newInviteTitle7': `Dear Crait user "${val[0]}", please enter your password to register`,
    'newInviteTitle8': `You have joined the team “${val[0]}”`,
    'Account registered. Welcome to Crait!': 'Account registered. Welcome to Crait!',
    'Welcome to Crait': 'Welcome to Crait, a secure and private messaging app',
    'Your email, phone number or username': 'Your email, phone number or username',
    'Name': 'Name',
    'Password': 'Password',
    'New password': 'New password',
    'Verification code': 'Verification code',
    'Continue': 'Continue',
    'Join': 'Join',
    'Next': 'Next',
    'Back': 'Back',
    'Done': 'Done',
    'Open Crait': 'Open Crait',
    'Open/Download Crait': 'Open/Download Crait',
    'Download Crait': 'Install Crait Now',
    'Go to sign up page': 'Go to sign up page',
    'You have joined Crait': 'You have joined Crait',
    'By registering, you agree to the ': 'By registering, you agree to the ',
    'User agreement': 'User agreement',
    'Send Code': 'Send Code',
    'Sorry, the password you inputted is empty.': 'Sorry, the password you inputted is empty.',
    'Sorry, the input is empty.': 'Sorry, the input is empty.',
    'Sorry, the name you inputted is empty.': 'Sorry, the name you inputted is empty.',
    'Sorry, the code you inputted is empty.': 'Sorry, the code you inputted is empty.',
    'Sorry, the phone number you inputted is invalid.': 'Sorry, the phone number you inputted is invalid.',
    'The username need to start with a letter and comprise 6-20 characters.': 'The username need to start with a letter and comprise 6-20 characters.',
    'The username only support two special characters: - and _': 'The username only support two special characters: - and _',
    'The password needs to have more than 6 letters': 'The password needs to have more than 6 letters',
    'inviteErrorText1': 'Sorry, the link has expired',
    'inviteErrorText2': 'You can ask the inviter to send you another invite link or click the button below to sign up yourself.',
    'inviteErrorText3': 'There are two possible causes for this problem',
    'inviteErrorText4': ' · The link was generated more than 7 days ago',
    'inviteErrorText5': ' · The URL of the link is incomplete',
    'Skip and verify later': 'Skip and verify later',
    'Enter email, phone or username to accept': 'Enter email, phone or username to accept',
    'Enter email, phone or username to register': 'Enter email, phone or username to register',
    'Start secure messaging': 'Join',
    'Accept': 'Accept',
    'Open in App': 'Open in App',
    'Your password': 'Your password',
    'Login to Crait with this account to start messaging': 'Open the app and sign in with the account to get started',
    'Not your account? ': 'Not your account? ',
    'Switch': 'Switch',
    'Tap': 'Tap',
    'icon in the top right corner': 'icon in the top right corner',
    'Click': 'Click',
    'open in browser': 'open in browser',
    'input your mobile number or email here': 'input your mobile number or email here'
  }
  let ZH_CN = {
    'title': 'Crait邀请',
    'inviteTitle0': `您的朋友${val[0]}邀请你加入${val[1]}`,
    'inviteTitle1': `您的朋友${val[0]}邀请你加入${val[1]}`,
    'inviteTitle3': `您被邀请加入群：${val[0]}`,
    'newInviteTitle0': `${val[0]} 正在使用Crait，赶快加入吧`,
    'newInviteTitle1': `${val[0]} 正在使用Crait，赶快加入吧`,
    'newInviteTitle3': `加密、安全的Crait群聊“${val[0]}”邀请您加入`,
    'newInviteTitle4': `Crait用户“${val[0]}”您好，请输入密码以接受邀请`,
    'newInviteTitle5': `您与“${val[0]}”已成为好友`,
    'newInviteTitle6': `你已加入群聊 “${val[0]}”`,
    'newInviteTitle7': `Crait用户“${val[0]}”您好，请请输入密码以注册账号`,
    'newInviteTitle8': `您已加入“${val[0]}”团队`,
    'Welcome to Crait': '欢迎使用Crait，一款安全、私密的聊天与协作工具',
    'Account registered. Welcome to Crait!': '注册成功，欢迎使用Crait！',
    'Your email, phone number or username': '请输入邮箱，手机号或用户名',
    'Name': '姓名',
    'Password': '密码',
    'New password': '密码',
    'Verification code': '验证码',
    'Continue': '继续',
    'Join': '加入',
    'Next': '下一步',
    'Back': '返回',
    'Done': '完成',
    'Open Crait': '打开 Crait',
    'Open/Download Crait': '打开/下载 Crait',
    'Download Crait': '立即安装Crait',
    'Go to sign up page': '前往注册页',
    'You have joined Crait': '你已加入 Crait',
    'By registering, you agree to the ': '注册即代表您同意 ',
    'User agreement': 'Crait用户协议',
    'Send Code': '获取验证码',
    'Sorry, the password you inputted is empty.': '抱歉，您输入的密码为空',
    'Sorry, the input is empty.': '抱歉，输入框为空',
    'Sorry, the name you inputted is empty.': '抱歉，您输入的姓名为空',
    'Sorry, the code you inputted is empty.': '抱歉，您输入的验证码为空',
    'Sorry, the phone number you inputted is invalid.': '抱歉，您输入的手机号有误',
    'The username need to start with a letter and comprise 6-20 characters.': '用户名需要以字母开始，长度在6-20个字符之间',
    'The username only support two special characters: - and _': '用户名仅支持这两个特殊字符：- 和 _',
    'The password needs to have more than 6 letters': '密码需长于6个字符',
    'inviteErrorText1': '抱歉，该邀请链接已失效',
    'inviteErrorText2': '您可以再从邀请人处获取一个邀请链接，或者点击下方按钮直接注册',
    'inviteErrorText3': '有两个原因可能导致这个问题',
    'inviteErrorText4': ' · 该链接是超过7天前生成的',
    'inviteErrorText5': ' · 该链接地址不完整',
    'Skip and verify later': '稍后验证',
    'Enter email, phone or username to accept': '请输入手机号、邮箱或用户名接受邀请',
    'Enter email, phone or username to register': '请输入手机号、邮箱或用户名注册账号',
    'Start secure messaging': '加入',
    'Accept': '接受邀请',
    'Open in App': 'App內打开',
    'Your password': '请输入您的密码',
    'Login to Crait with this account to start messaging': '打开app登录该账号即可开始使用',
    'Not your account? ': '不是你的账号？',
    'Switch': '点击切换',
    'Tap': '点击',
    'icon in the top right corner': '右上角的按钮',
    'Click': '点击',
    'open in browser': '在浏览器打开',
    'input your mobile number or email here': '请输入手机号、邮箱'
  }
  let ZH_TD = {
    'title': 'Crait邀請',
    'newInviteTitle0': `${val[0]} 正在使用Crait，趕快加入吧`,
    'newInviteTitle1': `${val[0]} 正在使用Crait，趕快加入吧`,
    'newInviteTitle3': `您已加入安全群聊“${val[0]}”`,
    'newInviteTitle4': `Crait用戶“${val[0]}”您好，請輸入密碼以接受邀請`,
    'newInviteTitle5': `您與“${val[0]}”已成為好友`,
    'newInviteTitle6': `你已加入群聊“${val[0]}”`,
    'newInviteTitle7': `Crait用戶“${val[0]}”您好，請輸入密碼以註冊帳號`,
    'newInviteTitle8': `您已加入“${val[0]}”團隊`,
    'Account registered. Welcome to Crait!': '注册成功，歡迎使用Crait！',
    'Welcome to Crait': '歡迎使用Crait，一款安全、私密的聊天與協作工具',
    'Sorry, the password you inputted is empty': '抱歉，您輸入的密碼為空',
    'Sorry, the input is empty.': '抱歉，輸入框為空',
    'Sorry, the name you inputted is empty.': '抱歉，您輸入的姓名為空',
    'Sorry, the code you inputted is empty.': '抱歉，您輸入的驗證碼為空',
    'Sorry, the phone number you inputted is invalid.': '抱歉，您輸入的手機號有誤',
    'The username need to start with a letter and comprise 6-20 characters.': '用戶名需要以字母開始，長度在6-20個字符之間',
    'The username only support two special characters: - and _': '用戶名僅支持這兩個特殊字元：-和_',
    'The password needs to have more than 6 letters': '密碼需長於6個字元',
    'inviteErrorText1': '抱歉，該邀請連結已失效',
    'inviteErrorText2': '您可以再從邀請人處獲取一個邀請連結，或者點擊下方按鈕直接注册',
    'inviteErrorText3': '有兩個原因可能導致這個問題',
    'inviteErrorText4': ' · 該連結是超過7天前生成的',
    'inviteErrorText5': ' · 該連結位址不完整',
    'Open/Download Crait': '下載/打開 Crait',
    'Download Crait': '立即安裝Crait',
    'Go to sign up page': '前往註冊頁',
    'Enter email, phone or username to accept': '請輸入手機號、郵箱或用戶名接受邀請',
    'Enter email, phone or username to register': '請輸入手機號、郵箱或用戶名註冊帳號',
    'Start secure messaging': '加入',
    'Accept': '接受邀請',
    'Open in App': 'App中打開',
    'Your password': '請輸入您的密碼',
    'Login to Crait with this account to start messaging': '打開app登錄該賬號即可開始使用',
    'Not your account? ': '不是你的賬號？',
    'Switch': '點擊切換',
    'Tap': '點擊',
    'icon in the top right corner': '右上角的按鈕',
    'Click': '點擊',
    'open in browser': '在瀏覽器打開',
    'input your mobile number or email here': '請輸入手機號、郵箱'
  }
  let ES = {
    'title': 'Crait Invitación',
    'newInviteTitle0': `${val[0]} está usando crait, únete ahora`,
    'newInviteTitle1': `${val[0]} está usando crait, únete ahora`,
    'newInviteTitle3': `El chat de grupo privado seguro "${val[0]}" lo invitó a unirse`,
    'newInviteTitle4': `Estimado usuario de Crait "${val[0]}", ingrese su contraseña para aceptar la invitación`,
    'newInviteTitle5': `Вы и "${val[0]}" подключены`,
    'newInviteTitle6': `Te has unido al chat grupal "${val[0]}"`,
    'newInviteTitle7': `Estimado usuario de Crait "${val[0]}", por favor ingrese su contraseña para registrarse`,
    'newInviteTitle8': `Te has unido al equipo “${val[0]}”`,
    'Account registered. Welcome to Crait!': 'Cuenta registrada.¡Bienvenido a crait!',
    'Welcome to Crait': 'Bienvenido a Crait, una aplicación de mensajería segura y privada',
    'Sorry, the password you inputted is empty': 'Lo siento, la contraseña introducida es vacio',
    'Sorry, the input is empty.': 'Lo siento, la entrada está vacía.',
    'Sorry, the name you inputted is empty.': ' Lo siento, el nombre que introdujo esta vacia.',
    'Sorry, the code you inputted is empty.': 'Lo siento, el código que introduciste está vacío.',
    'Sorry, the phone number you inputted is invalid.': 'Lo siento, el numero de telefono introducido no es válido.',
    'The username need to start with a letter and comprise 6-20 characters.': 'El nombre de usuario debe comenzar con una letra y comprenden 6 - 20 caracteres.',
    'The username only support two special characters: - and _': 'El nombre de usuario solo de Apoyo de dos caracteres especiales: - y _',
    'The password needs to have more than 6 letters': ' La contraseña debe tener mas de 6 letras',
    'inviteErrorText1': 'Lo siento, el enlace ha caducado',
    'inviteErrorText2': 'Usted puede pedir el invitador para otro enlace de invitacion, o haga clic en el boton de abajo para registrarse primero',
    'inviteErrorText3': 'Hay dos posibles causas para este problema',
    'inviteErrorText4': ' · La referencia fue generado hace mas de 7 dias',
    'inviteErrorText5': ' · La dirección de enlace no es completa',
    'Open/Download Crait': 'Descargar / Abrir Crait',
    'Download Crait': 'Instala Crait ahora',
    'Go to sign up page': 'Ir a la página de registro',
    'Enter email, phone or username to accept': 'Ingrese el correo electrónico, el teléfono o la contraseña para aceptar la invitación',
    'Enter email, phone or username to register': 'Introduzca el correo electrónico, teléfono o contraseña para registrarse',
    'Start secure messaging': 'Unirse',
    'Accept': 'Aceptar',
    'Open in App': 'abra en la aplicación',
    'Your password': 'Tu contraseña',
    'Login to Crait with this account to start messaging': 'Abra la aplicación e inicie sesión en la cuenta para comenzar',
    'Not your account? ': 'No es tu cuenta? ',
    'Switch': 'Cambiar',
    'Tap': 'Toque',
    'icon in the top right corner': 'icono en la esquina superior derecha',
    'Click': 'Haga clic',
    'open in browser': 'abrir en el navegador',
    'input your mobile number or email here': 'ingrese su número de móvil o correo electrónico aquí'
  }
  let RU = {
    'title': 'Crait приглашение',
    'newInviteTitle0': `${val[0]} использует crait, присоединяйтесь сейчас`,
    'newInviteTitle1': `${val[0]} использует crait, присоединяйтесь сейчас`,
    'newInviteTitle3': `Безопасный приватный групповой чат «${val[0]}» пригласил вас присоединиться`,
    'newInviteTitle4': `Уважаемый пользователь Crait «${val[0]}», пожалуйста, введите свой пароль, чтобы принять приглашение`,
    'newInviteTitle5': `Usted y "${val[0]}" han sido conectados`,
    'Account registered. Welcome to Crait!': 'счет зарегистрирован.добро пожаловать в crait!',
    'newInviteTitle6': `Вы присоединились к групповому чату «${val[0]}»`,
    'newInviteTitle7': `Уважаемый пользователь Crait «${val[0]}», пожалуйста, введите ваш пароль для регистрации`,
    'newInviteTitle8': `TВы присоединились к команде “${val[0]}”`,
    'Welcome to Crait': 'Добро пожаловать в Crait, приложение для безопасного и частного обмена сообщениями',
    'Sorry, the password you inputted is empty': 'прости, пароль, введенных пуста',
    'Sorry, the input is empty.': 'прости, вклад пуст.',
    'Sorry, the name you inputted is empty.': 'прости, как ты ввел пуст.',
    'Sorry, the code you inputted is empty.': 'прости, ты ввел кодекс пуст.',
    'Sorry, the phone number you inputted is invalid.': 'прости, номер телефона, на который ты ввел неверный.',
    'The username need to start with a letter and comprise 6-20 characters.': 'имя нужно начать с письмом и составляют 20 персонажей',
    'The username only support two special characters: - and _': 'имя только в поддержку двух специальных символов: - и _',
    'The password needs to have more than 6 letters': 'пароль должен иметь больше, чем 6 букв',
    'inviteErrorText1': 'прости, связь которых истек',
    'inviteErrorText2': 'вы можете спросить inviter еще предложить ссылку, или нажмите кнопку ниже, чтобы зарегистрироваться',
    'inviteErrorText3': 'есть два возможных причин этой проблемы,',
    'inviteErrorText4': ' · связь было подготовлено более 7 дней назад',
    'inviteErrorText5': ' · связь решения еще не завершена',
    'Open/Download Crait': 'Скачать / открыто Crait',
    'Download Crait': 'Установите Crait Now',
    'Go to sign up page': 'Перейти на страницу регистрации',
    'Enter email, phone or username to accept': 'Введите адрес электронной почты, телефон или пароль, чтобы принять приглашение',
    'Enter email, phone or username to register': 'введите адрес электронной почты, по телефону или пароль для регистрации',
    'Start secure messaging': 'Присоединиться',
    'Accept': 'принимать',
    'Open in App': 'откройте приложение',
    'Your password': 'Ваш пароль',
    'Login to Crait with this account to start messaging': 'Откройте приложение и войдите в учетную запись, чтобы начать',
    'Not your account? ': 'Не ваша учетная запись? ',
    'Switch': 'переключатель',
    'Tap': 'Нажмите',
    'icon in the top right corner': 'значок в правом верхнем углу',
    'Click': 'Нажмите',
    'open in browser': 'открыть в браузере',
    'input your mobile number or email here': 'введите номер мобильного телефона или адрес электронной почты здесь'
  }
  if (browserLanguage() === 'zh-CN') {
    return ZH_CN[key]
  } else if (browserLanguage() === 'zh-hant') {
    return ZH_TD[key]
  } else if (browserLanguage() === 'es–ES') {
    return ES[key]
  } else if (browserLanguage() === 'ru–RU') {
    return RU[key]
  } else {
    return EN_US[key]
  }
}

export default new Translate().translate



// WEBPACK FOOTER //
// ./src/new-login-2018/common/Translate.js